import React, { useState } from "react";
import {
  FaEye,
  FaEyeSlash,
  FaEnvelope,
  FaLock,
  FaUser,
  FaPhoneAlt,
} from "react-icons/fa";
import { AiOutlineNumber } from "react-icons/ai";

import { FcGoogle } from "react-icons/fc";
import regis_image from "../Assets/regis_image.png";
import { IoMdCloseCircleOutline } from "react-icons/io";
import "../Style/Register.css";
import { registerUser, sendOtp, validateOtp } from "../backend";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../firebase.js";

const Register = ({ setShowRegisterComponent, setShowLoginComponent }) => {
  const isMobile = window.innerWidth <= 768;
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [emailOtp, setEmailOtp] = useState("");
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [isEmailOtpValid, setIsEmailOtpValid] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    age: "",
    gender: "",
    password: "",
    confirmPassword: "",
    signInMethod: "manual",
  });

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const googleLogin = async () => {
    const e = null;
    signInWithPopup(auth, provider).then(async (result) => {
      setFormData((prevData) => ({
        ...prevData,
        email: result.user.email,
      }));
    });
  };
  const sendEmailOtp = async () => {
    if (!formData.email) {
      alert("Please enter email!");
      return;
    }
    try {
      const response = await sendOtp(formData.email);
      console.log("Send",response)
      if (response) {
        setEmailOtpSent(true);
        alert("OTP sent to your email.");
      } else {
        alert("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error sending email OTP", error);
      alert("An error occurred while sending the OTP.");
    }
  };
  const validateEmailOtp = async () => {
    try {
      const response = await validateOtp(formData.email, emailOtp);
      if (response) {
        setIsEmailOtpValid(true);
        alert("Email OTP validated successfully.");
      } else {
        alert("Invalid email OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error validating email OTP", error);
      alert("An error occurred while validating the OTP.");
    }
  };
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isEmailOtpValid) {
      alert("Please validate your email OTP before registering.");
      return;
    }
    // Validate form data
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    try {
      const response = await registerUser({
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        age: formData.age,
        gender: formData.gender,
        phoneNumber: formData.phoneNumber,
        password: formData.password,
      });
      console.log("Response", response);
      alert(`Registration successful! Welcome, ${response.user.firstName}`);
      setShowRegisterComponent(false); // Close register modal
    } catch (error) {
      alert(error.message || "Registration failed. Please try again.");
    }
  };

  return (
    <div className="register-container" onClick={(e) => e.stopPropagation()}>
      <div className="form-section">
        <h1 className="form-heading-h1">SIGN UP</h1>
        <p className="form-p1">
          Welcome to HOMOEOPATHIC HEALTH CARE & RESEARCH CENTER
        </p>
        <form className="main-form-input" onSubmit={handleSubmit}>
          <div className="form-group">
            <div className="input-container">
              <FaUser />
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-container">
              <FaUser />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="form-group">
            <div className="input-container">
              <FaEnvelope />
              <input
                type="email"
                name="email"
                placeholder="Email ID"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div
                className="input-container"
                style={{
                  flexDirection: "row",
                  width: emailOtpSent && !isEmailOtpValid ? "90%" : "",
                  margin: emailOtpSent && !isEmailOtpValid ? "auto" : "",
                }}
              >
                {!emailOtpSent && !isEmailOtpValid && (
                  <button
                    type="button"
                    onClick={sendEmailOtp}
                    className="verifi-btn"
                    style={{
                      padding: "3px 5px",
                      width: "90%",
                      margin: "auto",
                      backgroundColor:"#f3f1ff",
                      border:"none",
                      cursor:"pointer"
                    }}
                  >
                    Send Email OTP
                  </button>
                )}
                {emailOtpSent && !isEmailOtpValid && (
                  <div style={{ display: "flex" }}>
                    <input
                      type="number"
                      placeholder="OTP*"
                      value={emailOtp}
                      onChange={(e) => setEmailOtp(e.target.value)}
                      required
                      style={{width:"50%"}}
                    />
                    <button
                      type="button"
                      onClick={validateEmailOtp}
                      className="verifi-btn"
                      style={{ padding: "2px",width:"50%",backgroundColor:"#f3f1ff",boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",border:"none",cursor:"pointer" }}
                    >
                      Validate Email Otp
                    </button>
                  </div>
                )}
                {isEmailOtpValid && (
                  <div style={{ display: "flex", width: "100%" }}>
                    <input
                      type="number"
                      placeholder="OTP*"
                      value={emailOtp}
                      onChange={(e) => setEmailOtp(e.target.value)}
                      required
                    />
                  </div>
                )}
              </div>
           
          </div>
          <div className="input-container">
              <FaPhoneAlt />
              <input
                type="text"
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </div>
          <div className="form-group">
            <div className="input-container">
              {/* <AiOutlineNumber /> */}
              <input
                type="text"
                name="age"
                placeholder="Age"
                value={formData.age}
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-container">
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <div className="input-container">
              <FaLock />
              <input
                type={passwordVisible ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <span
                className="toggle-password"
                onClick={() => setPasswordVisible(!passwordVisible)}
              >
                {passwordVisible ? (
                  <FaEyeSlash size={23} color="var(--primary-color)" />
                ) : (
                  <FaEye size={23} color="var(--primary-color)" />
                )}
              </span>
            </div>
            <div className="input-container">
              <FaLock />
              <input
                type={confirmPasswordVisible ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <span
                className="toggle-password"
                onClick={() =>
                  setConfirmPasswordVisible(!confirmPasswordVisible)
                }
              >
                {confirmPasswordVisible ? (
                  <FaEyeSlash size={23} color="var(--primary-color)" />
                ) : (
                  <FaEye size={23} color="var(--primary-color)" />
                )}
              </span>
            </div>
          </div>
          <div className="terms-container">
            <input type="checkbox" id="terms" required />
            <label htmlFor="terms">
              I agree to all the <span>Terms</span> and{" "}
              <span>Privacy Policies</span>
            </label>
          </div>
          <button type="submit" className="create-account-btn">
            Create Account
          </button>
          <p className="login-link">
            Already have an account?{" "}
            <span
              onClick={() => {
                setShowRegisterComponent(false);
                setShowLoginComponent(true);
              }}
            >
              Login
            </span>
          </p>
          <div
            style={{
              display: "flex",
              width: "80%",
              margin: "auto",
              alignItems: "center",
            }}
          >
            <div className="border-line-regis"></div>
            <p className="or">Or Sign up with</p>
            <div className="border-line-regis"></div>
          </div>

          <div className="social-login">
            <div onClick={googleLogin}>
              <FcGoogle size={35} />
              <p className="google-btn">Login with Google</p>
            </div>
            {/* <div>
              <FaSquareFacebook size={35} color="#4267B2" />
              <p className="facebook-btn">Login with Facebook</p>
            </div> */}
          </div>
        </form>
      </div>
      {!isMobile ? (
        <div className="image-section-1">
          <img src={regis_image} alt="Doctor and patient" />
        </div>
      ) : (
        ""
      )}
      <div
        className="close-icon"
        onClick={() => setShowRegisterComponent(false)}
      >
        <IoMdCloseCircleOutline size={50} color="var(--tertiary)" />
      </div>
    </div>
  );
};

export default Register;
